import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckThick } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './premium.style';

export const BillingUsps: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Styled.BillingInformation>
      <Typography variant="h6">
        {t('forms.onboarding.premium.billing.warning')}
      </Typography>

      <Styled.BillingUsps>
        <Styled.BillingUsp>
          <Styled.BillingIcon>
            <Icon icon={CheckThick} />
          </Styled.BillingIcon>
          <Typography variant="buttonSmall">
            {t('forms.onboarding.premium.billing-usp.1')}
          </Typography>
        </Styled.BillingUsp>

        <Styled.BillingUsp>
          <Styled.BillingIcon>
            <Icon icon={CheckThick} />
          </Styled.BillingIcon>
          <Typography variant="buttonSmall">
            {t('forms.onboarding.premium.billing-usp.2')}
          </Typography>
        </Styled.BillingUsp>
      </Styled.BillingUsps>
    </Styled.BillingInformation>
  );
};
